export default __webpack_public_path__ + "static/media/alex_headshot.3f2a26df.jpeg";